import * as Sentry from '@sentry/react';
import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from 'serviceWorker';

// eslint-disable-next-line no-restricted-imports
import './index.css';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

Sentry.init({
  dsn: 'https://12d719a79f034d0b8415dfeb59a1d515@o1262547.ingest.sentry.io/4503917884342272',
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  environment: process.env.NODE_ENV || 'production',
  tracesSampleRate: 0.1,
});

// NOTE:
// React18のcreaterootに移行すると、編集モーダル周りで不具合が発生するため、暫定的にReactDOM.renderを使用
// React18の新機能を利用したい場合や、React19以降にアップデートする際には、createrootへの移行も併せて行う必要がある
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
